// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as Belt_Id from "@rescript/runtime/lib/es6/Belt_Id.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as JsxRuntime from "react/jsx-runtime";

let re = /^[0-9a-f]{2}(:[0-9a-f]{2}){5}$/i;

function fromString(str) {
  if (re.test(str)) {
    return str;
  }
}

function toString(str) {
  return str;
}

let stringCodec = {
  toString: toString,
  fromString: fromString
};

function toFloat(str) {
  return parseInt(str.split(":").join(""), 16);
}

function fromFloat(num) {
  let hex = num.toString(16).padStart(12, "0");
  if (isFinite(num) && num >= 0 && hex.length === 12) {
    return Stdlib_Array.fromInitializer(6, i => hex.substring((i << 1), (i << 1) + 2 | 0)).join(":");
  }
}

function nextMac(mac) {
  let num = toFloat(mac);
  return fromFloat(num + 1);
}

let cmp = Primitive_object.compare;

let Cmp = Belt_Id.MakeComparable({
  cmp: cmp
});

function MacAddress(props) {
  return JsxRuntime.jsx("span", {
    children: props.macAddress,
    className: "is-family-monospace"
  });
}

let jsonCodec = Jzon.string;

let make = MacAddress;

export {
  re,
  fromString,
  toString,
  stringCodec,
  toFloat,
  fromFloat,
  nextMac,
  Cmp,
  jsonCodec,
  make,
}
/* Cmp Not a pure module */
